import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Subject, takeUntil } from "rxjs";
import { MessageService } from "primeng/api";
import { MenuService } from "../../../services/menus/menu.service";

@Component({
  selector: 'app-delete-menu-item',
  templateUrl: './delete-menu-item.component.html',
  styleUrls: ['./delete-menu-item.component.scss']
})
export class DeleteMenuItemComponent implements OnInit {

  //#region Fields
  public unsubscribe: Subject<void> = new Subject<void>();
  public spinner: boolean = false;
  public menuItemId: string;
  //#endregion

  //#region Constructor
  constructor(
    private config: DynamicDialogConfig,
    private ref: DynamicDialogRef,
    private messageService: MessageService,
    private menuService: MenuService
  ) {
    if (this.config.data != undefined && this.config.data.id) {
      this.menuItemId = this.config.data.id;
    }
  }

  ngOnInit(): void {
  }
  //#endregion

  //#region Public Methods
  deleteMenuItem(menuItemId: string) {
    this.spinner = true;
    this.menuService.deleteMenuItem(menuItemId)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.ref.close(true);
        },
        error: errorResponse => {
          this.spinner = false;
          this.messageService.add({ severity: 'error', summary: "System error", life: 2000 });
        }
      });
  }

  cancel(): void {
    this.ref.close(false);
  }
  //#endregion
}
